import * as C from "react";
import { forwardRef as r } from "react";
const n = r(function(e, o) {
  return /* @__PURE__ */ C.createElement(
    "svg",
    {
      fill: "none",
      ref: o,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ C.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M15.5857 5.01746C14.8125 5.01746 9.16843 5.01746 8.48519 5.01746C3.79988 5.01746 1.11284 19.0175 4.61903 19.0175C7.57605 19.0175 7.9746 14.9233 12.0244 14.9233C15.2992 14.9233 17.2222 18.9665 19.4078 18.9665C22.9103 18.9644 20.2729 5.01746 15.5857 5.01746ZM8.51637 12.0164C7.21969 12.0164 6.16729 10.8496 6.16729 9.40941C6.16729 7.97126 7.21785 6.80443 8.51637 6.80443C9.81306 6.80443 10.8636 7.97126 10.8636 9.40941C10.8636 10.8476 9.81306 12.0164 8.51637 12.0164ZM14.3423 9.82147C13.9602 9.68888 13.7454 9.23602 13.8666 8.80967C13.986 8.38537 14.3937 8.14874 14.7776 8.28133C15.1596 8.41189 15.3763 8.86475 15.2551 9.29109C15.1339 9.71948 14.7261 9.95407 14.3423 9.82147ZM16.5427 11.7553C16.3608 12.404 15.7382 12.7671 15.1523 12.5631C14.5682 12.3612 14.2432 11.6697 14.4268 11.0189C14.6086 10.3702 15.2313 10.0071 15.8172 10.2111C16.4012 10.4151 16.7263 11.1066 16.5427 11.7553ZM16.1257 8.91983C15.5875 8.73012 15.2863 8.09162 15.4553 7.49392C15.6261 6.89418 16.1992 6.55964 16.7391 6.74935C17.2791 6.93498 17.5803 7.57552 17.4095 8.17322C17.2405 8.77295 16.6657 9.1075 16.1257 8.91983ZM18.1368 10.5783C18.0138 11.0046 17.6079 11.2413 17.224 11.1087C16.842 10.9761 16.6271 10.5232 16.7465 10.0948C16.8677 9.66849 17.2773 9.4339 17.6575 9.56445C18.0432 9.69909 18.2562 10.1499 18.1368 10.5783ZM9.70289 9.44817C9.70289 10.1927 9.16291 10.7925 8.49437 10.7925C7.82583 10.7925 7.28401 10.1907 7.28401 9.44817C7.28401 8.70767 7.82399 8.1059 8.49437 8.1059C9.16291 8.1059 9.70289 8.70767 9.70289 9.44817Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as Esports
};
